var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-recaptcha',{attrs:{"sitekey":_vm.recaptchaSiteKey,"loadRecaptchaScript":true},on:{"verify":_vm.setResponse,"expired":_vm.clearResponse,"error":_vm.clearResponse}}),_vm._v(" "),(_vm.hasError)?_c('v-messages',{attrs:{"value":[_vm.trans('app.confirm_captcha')],"color":`error`}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }